import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ISurveyFormDisplayRuleDomainLegend } from "../../../../../../../../@types/Proms";
import { CustomPromsDomainTotalLegend } from "../CustomPromsDomainTotalLegend/CustomPromsDomainTotalLegend";
import {
  ChartLegendContainer,
  Container,
  DateLabel,
  Divider,
  MainValueContainer,
  MainValueContainerFirst,
  MainValuesContainer,
  NumberLabel,
  TextLabel,
} from "./CustomPromsDomainTotalGraphLegend.style";

type CustomPromsGraphLegendProps = {
  mainValues: any;
  empty: boolean;
  showValues: boolean;
  legends: ISurveyFormDisplayRuleDomainLegend[];
};

export function CustomPromsDomainTotalGraphLegend({
  mainValues,
  empty,
  showValues,
  legends,
}: CustomPromsGraphLegendProps) {
  const { t } = useTranslation();

  const { min, max, average, minValueDate, maxValueDate } = mainValues;

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setDisabled(!min && !max && !average);
  }, [mainValues]);

  const chartLegendContainer = (
    <ChartLegendContainer paddingLeft={!showValues}>
      <CustomPromsDomainTotalLegend legends={legends} />
    </ChartLegendContainer>
  );

  const mainValuesContainer = (
    <MainValuesContainer>
      <MainValueContainerFirst>
        <NumberLabel disabled={disabled}>{average ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_average")}
        </TextLabel>
      </MainValueContainerFirst>
      <MainValueContainerFirst>
        <NumberLabel disabled={disabled}>{max ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_highest")}
        </TextLabel>
        <DateLabel disabled={disabled}>
          {dayjs(maxValueDate).format("MMM DD, YYYY") || "-"}
        </DateLabel>
      </MainValueContainerFirst>
      <MainValueContainer>
        <NumberLabel disabled={disabled}>{min ?? "-"}</NumberLabel>
        <TextLabel disabled={disabled}>
          {t("patientPage_proms_legend_lowest")}
        </TextLabel>
        <DateLabel disabled={disabled}>
          {dayjs(minValueDate).format("MMM DD, YYYY") || "-"}
        </DateLabel>
      </MainValueContainer>
    </MainValuesContainer>
  );

  return (
    <div style={{ position: "relative" }}>
      <Container>
        {showValues && mainValuesContainer}
        {!empty && <Divider />}
        {chartLegendContainer}
      </Container>
    </div>
  );
}
